import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { motion,   } from 'framer-motion';
// img
import CtaImg from "../../images/cta-img1.png";

export default function Cta() {
    return (
        <motion.section 
            // Section container with transparent theme and overflow hidden
            className='section cta-section my-4 my-md-0 position-relative overflow-hidden transparent-theme'>
            <Container>
                <Row>
                    <Col md={12}>
                        {/* CTA card with animation on initial load */}
                        <motion.div 
                            className="cta-card card transparent-card"
                            initial={{ scale: 0.9, opacity: 0 }} 
                            whileInView={{ scale: 1, opacity: 1 }} 
                            viewport={{ once: true }} 
                            transition={{ duration: 0.6, ease: "easeOut" }} 
                        >
                            <Row className='justify-content-center align-items-center'>
                                <Col lg={7}>
                                    {/* CTA content with a slide-in animation */}
                                    <motion.div 
                                        className='cta-content'
                                        initial={{ x: -50, opacity: 0 }} 
                                        whileInView={{ x: 0, opacity: 1 }} 
                                        viewport={{ once: true }} 
                                        transition={{ delay: 0.2, duration: 0.6 }}
                                    >
                                        {/* Headline with entrance animation */}
                                        <motion.h1 
                                            className='fw-medium text-primary display-5 text-shadow mb-4'
                                            initial={{ y: 20, opacity: 0 }} 
                                            whileInView={{ y: 0, opacity: 1 }} 
                                            viewport={{ once: true }}
                                            transition={{ delay: 0.4, duration: 0.6 }} 
                                        >
                                            Find Your Dream Home Today!
                                        </motion.h1>
                                        {/* Subheading with entrance animation */}
                                        <motion.p 
                                            className="text-dark opacity-85 mb-4"
                                            initial={{ y: 20, opacity: 0 }} 
                                            whileInView={{ y: 0, opacity: 1 }}
                                            viewport={{ once: true }}
                                            transition={{ delay: 0.6, duration: 0.6 }}
                                        >
                                            Join thousands of happy homeowners who found their perfect property through our platform.
                                        </motion.p>
                                        {/* 
                                         */}
                                        {/* Extra info with badges */}
                                        <motion.div 
                                            className="mt-3 d-flex align-items-center gap-3"
                                            initial={{ y: 20, opacity: 0 }}
                                            whileInView={{ y: 0, opacity: 1 }}
                                            viewport={{ once: true }}
                                            transition={{ delay: 0.8, duration: 0.6 }}
                                        >
                                            <div className="d-flex align-items-center primary-border-badge">
                                                <i className="bi bi-check-circle-fill text-success me-2"></i>
                                                <span>Free Property Consultation</span>
                                            </div>
                                            <div className="d-flex align-items-center primary-border-badge">
                                                <i className="bi bi-shield-check text-primary me-2"></i>
                                                <span>Secure Process</span>
                                            </div>
                                        </motion.div>
                                    </motion.div>
                                </Col>
                                <Col sm={8} lg={5}>
                                    {/* Image and floating badge */}
                                    <motion.div 
                                        className='cta-right-content position-relative'
                                        initial={{ x: 50, opacity: 0 }} 
                                        whileInView={{ x: 0, opacity: 1 }} 
                                        viewport={{ once: true }}
                                        transition={{ delay: 0.4, duration: 0.6 }}
                                    >
                                        <motion.img 
                                            src={CtaImg} 
                                            alt="CTA image"
                                            className='img-fluid cta-img primary-border-image'
                                            whileHover={{ scale: 1.05 }} 
                                            transition={{ duration: 0.3 }} 
                                        />
                                        {/* Floating badge with animation */}
                                        <motion.div 
                                            className="floating-badge primary-border-badge"
                                            animate={{ 
                                                y: [0, -10, 0], 
                                                rotate: [0, 5, 0] 
                                            }}
                                            transition={{ 
                                                duration: 2,
                                                repeat: Infinity, 
                                                ease: "easeInOut"
                                            }}
                                        >
                                            {/* <div className="badge-content">
                                                <i className="bi bi-star-fill text-warning"></i>
                                                <span>4.9/5 Rating</span>
                                            </div> */}
                                        </motion.div>
                                    </motion.div>
                                </Col>
                            </Row>
                        </motion.div>
                    </Col>
                </Row>
                <Row>
                <Col md={12} className="text-center">
                    <Button
                         variant="outline-primary"
                         size="lg"
                         onClick={() => window.open("https://docs.google.com/forms/u/1/d/e/1FAIpQLSd_7Mh2uufrf7Jx_mRo14WTi14Z-hW0j3Ay9tZx4Czrw5AfLA/viewform", "_blank")}
                    >
                      Book Your Townhomes
                   </Button>
                  </Col>
                </Row>
            </Container>
        </motion.section>
    );
}
